(function () {
  'use strict';

  var config = window.VenucastSolutionFinderConfig;
  if (!config) return;

  document.querySelectorAll('[data-solution-finder]').forEach(initFinder);

  function initFinder(root) {
    var storageKey = 'venucast_solution_finder_v7';
    var loadedProducts = {};
    var state = {
      answers: {},
      currentIndex: 0,
      started: false,
      completed: false,
      rule: null,
      category: '',
      presetUseCase: '',
      attemptId: ''
    };

    var tool = root.querySelector('[data-finder-tool]');
    var questionCard = root.querySelector('[data-finder-question-card]');
    var questionHost = root.querySelector('[data-finder-question]');
    var resultHost = root.querySelector('[data-finder-result]');
    var progressBar = root.querySelector('[data-finder-progress-bar]');
    var progressLabel = root.querySelector('[data-finder-progress-label]');
    var contextBadge = root.querySelector('[data-finder-context]');
    var startButton = root.querySelector('[data-finder-start]');
    var startActions = root.querySelector('[data-finder-start-actions]');
    var logEndpoint = normalizeEndpoint(root.getAttribute('data-log-endpoint'));
    var guidanceEndpoint = normalizeEndpoint(root.getAttribute('data-guidance-endpoint')) || 'https://ai-monitor.avantree.com/api/customer-guidance';
    var params = new URLSearchParams(window.location.search);
    var storefrontRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    state.presetUseCase = normalizeUseCase(params.get('use_case'));
    state.category = normalizeTextParam(params.get('category'));

    restoreSession();
    if (state.presetUseCase || state.category) {
      state.answers = state.presetUseCase ? { solutionType: solutionTypeForUseCase(state.presetUseCase), useCase: state.presetUseCase } : {};
      state.currentIndex = 0;
      state.started = false;
      state.attemptId = '';
    }

    startButton.addEventListener('click', function () { startFinder(false, 'hero'); });
    root.querySelectorAll('[data-finder-help]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('solution_finder_cta_clicked', {
          cta_type: link.getAttribute('data-finder-help'),
          recommended_setup: state.rule ? state.rule.id : '',
          result: state.completed ? 'recommendation_generated' : 'finder_help'
        });
      });
    });

    window.addEventListener('beforeunload', function () {
      if (!state.started || state.completed) return;
      var flow = getFlow();
      var currentQuestion = flow[state.currentIndex] || 'unknown';
      track('solution_finder_abandoned', {
        stuck_at_question: currentQuestion,
        completed_answers: Object.keys(state.answers).filter(function (key) { return key !== 'notes'; }).join(',') || 'none'
      }, true);
    });

    if (state.presetUseCase) {
      startFinder(true, 'context');
    } else if (state.started && Object.keys(state.answers).length) {
      showResumeState();
    }

    function startFinder(fromContext, source) {
      if (!state.started) {
        state.started = true;
        state.attemptId = state.attemptId || newAttemptId();
        track('solution_finder_started', {
          start_source: source,
          entry_page: window.location.pathname + window.location.search,
          solution_type: state.answers.solutionType || '',
          use_case: state.answers.useCase || '',
          category: state.category || ''
        });
      }

      startActions.hidden = true;
      tool.hidden = false;
      resultHost.hidden = true;
      questionCard.hidden = false;
      state.currentIndex = fromContext || state.presetUseCase ? 0 : state.currentIndex;
      setContextBadge();
      renderQuestion();
      saveSession();
      scrollToTool();
    }

    function showResumeState() {
      startButton.textContent = 'Continue My Setup';
    }

    function getFlow() {
      var flow = [];
      if (!state.presetUseCase) {
        flow.push('solutionType');
        if (state.answers.solutionType !== 'caption_display') flow.push('useCase');
      }
      if (state.answers.solutionType === 'assistive_listening') {
        flow.push('venueCapacity', 'adaCompliance', 'receiverTarget', 'receiverPreference');
      } else {
        flow.push('receiverTarget');
      }
      flow.push('audioSource', 'barriers', 'rangeFeet');
      return flow;
    }

    function renderQuestion() {
      var flow = getFlow();
      if (state.currentIndex >= flow.length) {
        generateRecommendation();
        return;
      }

      var key = flow[state.currentIndex];
      var progress = Math.round(((state.currentIndex + 1) / flow.length) * 100);
      progressBar.style.width = progress + '%';
      progressLabel.textContent = (state.currentIndex + 1) + ' of ' + flow.length;

      if (key === 'venueCapacity') {
        renderCapacityQuestion(key);
        return;
      }

      if (key === 'receiverTarget') {
        renderReceiverTargetQuestion(key);
        return;
      }

      if (key === 'rangeFeet') {
        renderRangeQuestion(key);
        return;
      }

      var question = getQuestion(key);
      var currentAnswer = state.answers[key];
      var isMultiple = key === 'receiverPreference';
      var optionsMarkup = question.options.map(function (option) {
        var selected = isMultiple
          ? Array.isArray(currentAnswer) && currentAnswer.indexOf(option.value) !== -1
          : currentAnswer === option.value;
        return '<button type="button" class="sf-option' + (selected ? ' is-selected' : '') + '" data-answer="' + option.value + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
          (option.image ? '<span class="sf-option__icon sf-option__icon--image"><img src="' + option.image + '" alt=""></span>' : (option.icon ? '<span class="sf-option__icon" aria-hidden="true">' + option.icon + '</span>' : '')) +
          '<span class="sf-option__content"><span class="sf-option__label">' + option.label + '</span>' +
          (option.description ? '<span class="sf-option__description">' + option.description + '</span>' : '') + '</span>' +
          (isMultiple ? '<span class="sf-option__check" aria-hidden="true">' + (selected ? '✓' : '') + '</span>' : '') +
          '</button>';
      }).join('');

      questionHost.innerHTML =
        '<h2>' + question.title + '</h2>' +
        (question.helper ? '<p class="sf-question__helper">' + question.helper + '</p>' : '') +
        (question.preview || '') +
        (isMultiple ? '<div class="sf-multi-callout"><strong>Select one or more</strong><span>Each selected card will show a checkmark. AuraClip will make up at least 60% of the final receiver plan.</span></div>' : '') +
        '<div class="sf-options sf-options--' + key + '" role="group" aria-label="' + question.title + '">' + optionsMarkup + '</div>' +
        '<div class="sf-question__actions">' +
          '<button type="button" class="sf-back" data-finder-back' + (state.currentIndex === 0 ? ' hidden' : '') + '>← Back</button>' +
          (isMultiple ? '<button type="button" class="sf-button sf-button--primary" data-finder-continue' + (!Array.isArray(currentAnswer) || !currentAnswer.length ? ' disabled' : '') + '>Continue</button>' : '<span></span>') +
        '</div>';

      questionHost.querySelectorAll('[data-answer]').forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.getAttribute('data-answer');
          if (isMultiple) {
            updateMultipleAnswer(key, value);
            renderQuestion();
            return;
          }
          state.answers[key] = value;
          clearDependentAnswers(key);
          if (key === 'solutionType' && value === 'caption_display') state.answers.useCase = 'conference_caption';
          recordAnswer(key, value);
          state.currentIndex += 1;
          saveSession();
          renderQuestion();
        });
      });

      bindBackButton();
      var continueButton = questionHost.querySelector('[data-finder-continue]');
      if (continueButton) {
        continueButton.addEventListener('click', function () {
          if (!state.answers[key] || !state.answers[key].length) return;
          recordAnswer(key, state.answers[key]);
          state.currentIndex += 1;
          saveSession();
          renderQuestion();
        });
      }
    }

    function renderCapacityQuestion(key) {
      var current = typeof state.answers[key] === 'number' ? state.answers[key] : '';
      questionHost.innerHTML =
        '<h2>What is the venue’s maximum seating or audience capacity?</h2>' +
        '<p class="sf-question__helper">Enter the largest audience expected in this listening area. We use this to match published product range and show an ADA planning quantity.</p>' +
        '<form class="sf-capacity" data-capacity-form novalidate>' +
          '<label for="FinderCapacity-' + root.getAttribute('data-section-id') + '">Maximum people or seats</label>' +
          '<input id="FinderCapacity-' + root.getAttribute('data-section-id') + '" type="number" inputmode="numeric" min="1" max="100000" step="1" value="' + current + '" placeholder="Example: 300" data-capacity-input>' +
          '<p class="sf-capacity__error" data-capacity-error hidden>Please enter a whole number from 1 to 100,000.</p>' +
          '<div class="sf-capacity__buttons">' +
            '<button type="submit" class="sf-button sf-button--primary">Continue</button>' +
            '<button type="button" class="sf-button sf-button--secondary" data-capacity-unknown>I’m not sure</button>' +
          '</div>' +
        '</form>' +
        '<div class="sf-question__actions"><button type="button" class="sf-back" data-finder-back' + (state.currentIndex === 0 ? ' hidden' : '') + '>← Back</button><span></span></div>';

      var form = questionHost.querySelector('[data-capacity-form]');
      var input = questionHost.querySelector('[data-capacity-input]');
      var error = questionHost.querySelector('[data-capacity-error]');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var value = Number(input.value);
        if (!Number.isInteger(value) || value < 1 || value > 100000) {
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        state.answers[key] = value;
        recordAnswer(key, value);
        state.currentIndex += 1;
        saveSession();
        renderQuestion();
      });
      input.addEventListener('input', function () {
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      });
      questionHost.querySelector('[data-capacity-unknown]').addEventListener('click', function () {
        state.answers[key] = 'not_sure';
        recordAnswer(key, 'not_sure');
        state.currentIndex += 1;
        saveSession();
        renderQuestion();
      });
      bindBackButton();
    }

    function renderReceiverTargetQuestion(key) {
      var suggested = getSuggestedReceiverRange();
      var current = typeof state.answers[key] === 'string' ? state.answers[key] : suggested;
      state.answers[key] = current;
      var isAda = state.answers.adaCompliance === 'yes';
      var solutionType = state.answers.solutionType;
      var title = isAda ? 'Choose the ADA receiver quantity range' : 'How many venue-provided receivers should we plan for?';
      var helper = isAda
        ? 'We selected the range that contains the capacity-based ADA reference. You can change it before continuing.'
        : 'Choose the closest planning range. You can confirm the exact quantity later.';
      if (solutionType === 'audio_distribution') {
        title = 'How many rooms, zones or speakers should we plan for?';
        helper = 'Choose the closest range for the speaker distribution plan. No personal headphones will be added.';
      }
      if (solutionType === 'caption_display') {
        title = 'How many personal caption displays should we plan for?';
        helper = 'Choose the closest range for phones or displays that will show conference caption text.';
      }
      var reference = typeof state.answers.venueCapacity === 'number' ? getAdaCounts(state.answers.venueCapacity).receivers : null;
      var rangeMarkup = config.quantityRanges.map(function (range) {
        var selected = range.value === current;
        return '<button type="button" class="sf-option sf-option--range' + (selected ? ' is-selected' : '') + '" data-target-range="' + range.value + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
          '<span class="sf-option__content"><span class="sf-option__label">' + range.label + '</span></span>' +
          '<span class="sf-option__check" aria-hidden="true">' + (selected ? '✓' : '') + '</span>' +
        '</button>';
      }).join('');

      questionHost.innerHTML =
        '<h2>' + title + '</h2>' +
        '<p class="sf-question__helper">' + helper + '</p>' +
        (reference ? '<p class="sf-target-reference">Capacity reference: <strong>' + reference + ' receivers → ' + getQuantityRangeLabel(receiverRangeForCount(reference)) + '</strong></p>' : '') +
        '<div class="sf-options sf-options--quantity" role="group" aria-label="' + title + '">' + rangeMarkup + '</div>' +
        '<div class="sf-capacity__buttons"><button type="button" class="sf-button sf-button--primary" data-target-next>Next</button></div>' +
        '<div class="sf-question__actions"><button type="button" class="sf-back" data-finder-back>← Back</button><span></span></div>';

      questionHost.querySelectorAll('[data-target-range]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.answers[key] = button.getAttribute('data-target-range');
          saveSession();
          renderReceiverTargetQuestion(key);
        });
      });
      questionHost.querySelector('[data-target-next]').addEventListener('click', function () {
        recordAnswer(key, state.answers[key]);
        state.currentIndex += 1;
        saveSession();
        renderQuestion();
      });
      bindBackButton();
    }

    function renderRangeQuestion(key) {
      var current = typeof state.answers[key] === 'number' ? state.answers[key] : '';
      questionHost.innerHTML =
        '<h2>How far is the audio source from the last row or furthest listener?</h2>' +
        '<p class="sf-question__helper">Measure from the mixer, soundboard or audio device to the furthest person who needs the broadcast. We use this to check product range.</p>' +
        '<form class="sf-capacity" data-range-form novalidate>' +
          '<label for="FinderRange-' + root.getAttribute('data-section-id') + '">Distance in feet</label>' +
          '<input id="FinderRange-' + root.getAttribute('data-section-id') + '" type="number" inputmode="numeric" min="1" max="10000" step="1" value="' + current + '" placeholder="Example: 150" data-range-input>' +
          '<p class="sf-capacity__error" data-range-error hidden>Please enter a whole number from 1 to 10,000.</p>' +
          '<div class="sf-capacity__buttons">' +
            '<button type="submit" class="sf-button sf-button--primary">Continue</button>' +
            '<button type="button" class="sf-button sf-button--secondary" data-range-unknown>I’m not sure</button>' +
          '</div>' +
        '</form>' +
        '<div class="sf-question__actions"><button type="button" class="sf-back" data-finder-back>← Back</button><span></span></div>';

      var form = questionHost.querySelector('[data-range-form]');
      var input = questionHost.querySelector('[data-range-input]');
      var error = questionHost.querySelector('[data-range-error]');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var value = Number(input.value);
        if (!Number.isInteger(value) || value < 1 || value > 10000) {
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        state.answers[key] = value;
        recordAnswer(key, value);
        state.currentIndex += 1;
        saveSession();
        renderQuestion();
      });
      input.addEventListener('input', function () {
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      });
      questionHost.querySelector('[data-range-unknown]').addEventListener('click', function () {
        state.answers[key] = 'not_sure';
        recordAnswer(key, 'not_sure');
        state.currentIndex += 1;
        saveSession();
        renderQuestion();
      });
      bindBackButton();
    }

    function getSuggestedReceiverRange() {
      if (typeof state.answers.venueCapacity === 'number') return receiverRangeForCount(getAdaCounts(state.answers.venueCapacity).receivers);
      return state.answers.solutionType === 'assistive_listening' ? '4-10' : '1-3';
    }

    function receiverRangeForCount(count) {
      if (count <= 3) return '1-3';
      if (count <= 10) return '4-10';
      if (count <= 20) return '11-20';
      return '20+';
    }

    function getQuantityRangeLabel(value) {
      var range = config.quantityRanges.find(function (item) { return item.value === value; });
      return range ? range.label : 'Confirm range';
    }

    function getPlanningRange() {
      var value = state.answers.receiverTarget;
      if (value === '1-3') return { value: value, label: '1–3', min: 1, max: 3 };
      if (value === '4-10') return { value: value, label: '4–10', min: 4, max: 10 };
      if (value === '11-20') return { value: value, label: '11–20', min: 11, max: 20 };
      if (value === '20+') return { value: value, label: '20+', min: 20, max: null };
      return null;
    }

    function bindBackButton() {
      var backButton = questionHost.querySelector('[data-finder-back]');
      if (!backButton) return;
      backButton.addEventListener('click', function () {
        state.currentIndex = Math.max(0, state.currentIndex - 1);
        renderQuestion();
      });
    }

    function getQuestion(key) {
      if (key === 'solutionType') {
        return { title: 'What kind of system do you need?', helper: 'Choose one. We’ll ask about the specific scenario next.', options: config.solutionTypes };
      }
      if (key === 'useCase') {
        return {
          title: 'Where will you use it?',
          helper: 'Choose the scenario that is closest to your space or event.',
          options: config.useCases.filter(function (option) { return option.solutionType === state.answers.solutionType; })
        };
      }
      if (key === 'adaCompliance') {
        var capacity = state.answers.venueCapacity;
        var preview = '';
        if (typeof capacity === 'number') {
          var counts = getAdaCounts(capacity);
          preview = '<aside class="sf-ada-preview"><span class="sf-ada-preview__icon" aria-hidden="true">♿</span><div><strong>' + capacity.toLocaleString() + ' seats → ADA reference: ' + counts.receivers + ' receivers</strong><p>' + getAdaCalculation(capacity, counts.receivers) + '. Includes ' + counts.hearingAidCompatible + ' hearing-aid-compatible receivers when an assistive listening system is required.</p><p><strong>If you choose ADA planning, this quantity will be pre-filled on the next step. You can review or change it before continuing.</strong></p></div></aside>';
        }
        return {
          title: 'Do you need this system for ADA planning?',
          helper: (typeof capacity === 'number' ? 'Choose how the recommendation should use the capacity-based ADA reference. ' : '') + 'ADA planning is not automatically mandatory for every charitable organization. Coverage depends on the operator and facility. Religious organizations and entities controlled by them are generally exempt from ADA Title III; other nonprofits serving the public may be covered.',
          preview: preview,
          options: config.adaComplianceOptions
        };
      }
      if (key === 'receiverPreference') {
        return { title: 'Which Auracast receivers do you prefer?', helper: 'AuraClip (VRC-240) will provide at least 60% of the receiver plan. Choose one or more receiver styles for the remaining share.', options: config.receiverPreferences };
      }
      if (key === 'audioSource') {
        return {
          title: 'What audio source do you have?',
          helper: 'Most venue systems connect to a mixer / soundboard or a computer and other 3.5 mm audio-out device.',
          options: config.audioSources
        };
      }
      return { title: 'Are there walls, separation or multiple listening areas?', helper: 'Wireless range is normally published for line-of-sight use. Concrete, people and interference can reduce usable coverage.', options: config.barriers };
    }

    function updateMultipleAnswer(key, value) {
      var selected = Array.isArray(state.answers[key]) ? state.answers[key].slice() : [];
      if (value === 'not_sure') {
        selected = selected.length === 1 && selected[0] === value ? [] : [value];
      } else {
        selected = selected.filter(function (item) { return item !== 'not_sure'; });
        var index = selected.indexOf(value);
        if (index === -1) selected.push(value);
        else selected.splice(index, 1);
      }
      state.answers[key] = selected;
      saveSession();
    }

    function clearDependentAnswers(key) {
      if (key === 'solutionType') {
        delete state.answers.useCase;
      }
      if (key === 'solutionType' || key === 'useCase') {
        delete state.answers.venueCapacity;
        delete state.answers.adaCompliance;
        delete state.answers.receiverTarget;
        delete state.answers.receiverPreference;
        delete state.answers.audioSource;
        delete state.answers.barriers;
        delete state.answers.rangeFeet;
      }
      if (key === 'venueCapacity' || key === 'adaCompliance') {
        delete state.answers.receiverTarget;
      }
    }

    function recordAnswer(key, value) {
      track('solution_finder_answered', {
        question: key,
        answer: Array.isArray(value) ? value.join(',') : value,
        next_question: getFlow()[state.currentIndex + 1] || 'complete',
        entry_page: window.location.pathname + window.location.search,
        use_case: state.answers.useCase || ''
      });
    }

    function generateRecommendation() {
      questionHost.innerHTML = '<h2>Creating your setup plan</h2><p class="sf-question__helper">One moment…</p>';
      fetch(guidanceEndpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          brand: 'venucast',
          experience_name: 'build_my_venue_setup',
          session_id: state.attemptId,
          visitor_id: state.attemptId,
          question_event_id: newUuid(),
          response_event_id: newUuid(),
          question: '',
          answers: state.answers,
          page_url: window.location.href,
          page_title: document.title,
          locale: document.documentElement.lang || 'en-US',
          intent: 'venue_design'
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('guidance_unavailable');
        return response.json();
      }).then(function (result) {
        if (!result.handled || !result.recommendation_rule_ids || !result.recommendation_rule_ids.length) {
          renderSharedGap(result);
          return;
        }
        renderSharedResult(result);
      }).catch(function () { renderSharedGap(null); });
    }

    function renderSharedResult(result) {
      var ruleId = result.recommendation_rule_ids[0];
      state.rule = { id: ruleId, recommendation: { title: result.answer || ruleId } };
      state.completed = true;
      questionCard.hidden = true;
      resultHost.hidden = false;
      var products = (result.recommendedProducts || []).map(function (product) {
        var href = product.handle ? storefrontUrl('products/' + encodeURIComponent(product.handle)) : storefrontUrl('collections/view-all-products');
        return '<a class="sf-product-card" href="' + escapeHtml(href) + '" data-product-link="' + escapeHtml(product.id) + '"><strong>' + escapeHtml(product.name || product.sku) + '</strong><span>View product →</span></a>';
      }).join('');
      resultHost.innerHTML =
        '<div class="sf-result__heading"><p class="sf-result__intro">Your V1 setup plan</p><div class="sf-result__nav"><button class="sf-back sf-result__back" type="button" data-result-back>← Back to answers</button><button class="sf-restart" type="button" data-finder-restart>Start Over</button></div></div>' +
        '<article class="sf-result-summary"><span class="sf-result-summary__icon" aria-hidden="true">✓</span><div><h2>Verified recommendation</h2><p>' + escapeHtml(result.answer) + '</p></div></article>' +
        renderInstallationReassurance('straightforward') +
        '<div class="sf-product-groups">' + products + '</div>' +
        '<div class="sf-result__actions"><a class="sf-button sf-button--secondary" href="' + advisorUrl() + '" data-result-cta="expert_email">Confirm With an Expert by Email</a></div>';
      bindSharedResultNavigation();
      saveSession();
      track('solution_finder_recommendation', {
        recommended_setup: ruleId,
        recommended_products: (result.recommendedProducts || []).map(function (product) { return product.id; }).join(','),
        answer_patch: state.answers,
        guidance_trace: guidanceTrace(result)
      });
      updateHelpLinks();
      scrollToTool();
    }

    function renderSharedGap(result) {
      state.rule = null;
      state.completed = true;
      questionCard.hidden = true;
      resultHost.hidden = false;
      resultHost.innerHTML =
        '<div class="sf-result__heading"><p class="sf-result__intro">V1 knowledge check</p><div class="sf-result__nav"><button class="sf-back sf-result__back" type="button" data-result-back>← Back to answers</button><button class="sf-restart" type="button" data-finder-restart>Start Over</button></div></div>' +
        '<article class="sf-result-summary"><span class="sf-result-summary__icon" aria-hidden="true">?</span><div><h2>Expert confirmation needed</h2><p>There is not yet a verified V1 recommendation for this venue setup. We won’t guess.</p></div></article>' +
        '<div class="sf-result__actions"><a class="sf-button sf-button--secondary" href="' + advisorUrl() + '" data-result-cta="expert_email">Confirm With an Expert by Email</a></div>';
      bindSharedResultNavigation();
      saveSession();
      track('solution_finder_knowledge_gap', { answer_patch: state.answers, guidance_trace: guidanceTrace(result) });
      updateHelpLinks();
      scrollToTool();
    }

    function bindSharedResultNavigation() {
      resultHost.querySelector('[data-finder-restart]').addEventListener('click', restart);
      resultHost.querySelector('[data-result-back]').addEventListener('click', function () {
        state.completed = false;
        resultHost.hidden = true;
        questionCard.hidden = false;
        state.currentIndex = Math.max(0, getFlow().length - 1);
        saveSession();
        renderQuestion();
        scrollToTool();
      });
      resultHost.querySelectorAll('[data-result-cta], [data-product-link]').forEach(function (link) {
        link.addEventListener('click', function () {
          track('solution_finder_cta_clicked', {
            cta_type: link.getAttribute('data-result-cta') || 'product_detail',
            product_id: link.getAttribute('data-product-link') || '',
            result: state.rule ? state.rule.id : ''
          });
        });
      });
    }

    function guidanceTrace(result) {
      return {
        brand: 'venucast',
        experience_name: 'build_my_venue_setup',
        knowledge_version: result && result.knowledge_version || 'V1',
        product_fact_ids: result && result.product_fact_ids || [],
        compatibility_rule_ids: result && result.compatibility_rule_ids || [],
        recommendation_rule_ids: result && result.recommendation_rule_ids || [],
        decision: result && result.decision || 'UNKNOWN',
        knowledge_coverage: result && result.knowledge_coverage || 'GAP'
      };
    }

    function renderResult(rule) {
      var groups = getResultGroups(rule);

      resultHost.innerHTML =
        '<div class="sf-result__heading"><p class="sf-result__intro">Your setup plan</p><div class="sf-result__nav"><button class="sf-back sf-result__back" type="button" data-result-back>← Back to answers</button><button class="sf-restart" type="button" data-finder-restart>Start Over</button></div></div>' +
        '<article class="sf-result-summary">' +
          '<span class="sf-result-summary__icon" aria-hidden="true">✓</span>' +
          '<div><h2>Your requirements</h2><p>' + buildRequirementsSummary() + '</p></div>' +
        '</article>' +
        renderAdaGuidance() +
        '<div class="sf-product-groups">' +
          renderProductGroup('Recommended transmitter', 'transmitter', groups.transmitter) +
          renderProductGroup(getListeningGroupTitle(), 'receivers', groups.receivers) +
          renderProductGroup('Recommended accessories', 'accessories', groups.accessories) +
        '</div>' +
        renderInstallationReassurance('self_install') +
        '<div class="sf-result__actions">' +
          '<button class="sf-button sf-button--primary" type="button" data-add-all disabled>Preparing cart…</button>' +
          '<a class="sf-button sf-button--secondary" href="' + advisorUrl() + '" data-result-cta="expert_email">Confirm With an Expert by Email</a>' +
        '</div>' +
        '<p class="sf-cart-note" data-cart-status aria-live="polite">Items with a quantity that needs confirmation will be added as quantity 1 so you can review them in the cart.</p>' +
        '<div class="sf-notes"><label for="FinderNotes-' + root.getAttribute('data-section-id') + '">Anything unusual about your setup?</label>' +
          '<textarea id="FinderNotes-' + root.getAttribute('data-section-id') + '" data-finder-notes placeholder="Example: We have a 300-seat church, concrete side rooms and an Allen & Heath mixer."></textarea>' +
        '</div>';

      var notes = resultHost.querySelector('[data-finder-notes]');
      notes.value = state.answers.notes || '';
      notes.addEventListener('input', function () {
        state.answers.notes = notes.value;
        saveSession();
        updateHelpLinks();
        var advisor = resultHost.querySelector('[data-result-cta="expert_email"]');
        if (advisor) advisor.href = advisorUrl();
      });

      resultHost.querySelector('[data-finder-restart]').addEventListener('click', restart);
      resultHost.querySelector('[data-result-back]').addEventListener('click', function () {
        state.completed = false;
        resultHost.hidden = true;
        questionCard.hidden = false;
        state.currentIndex = Math.max(0, getFlow().length - 1);
        saveSession();
        renderQuestion();
        scrollToTool();
      });
      resultHost.querySelector('[data-add-all]').addEventListener('click', function () { addAllToCart(groups); });
      resultHost.querySelectorAll('[data-result-cta], [data-product-link]').forEach(function (link) {
        link.addEventListener('click', function () {
          track('solution_finder_cta_clicked', {
            cta_type: link.getAttribute('data-result-cta') || 'product_detail',
            product_id: link.getAttribute('data-product-link') || '',
            result: rule.id
          });
        });
      });
    }

    function renderInstallationReassurance(profile) {
      var template = root.querySelector('[data-finder-installation-profile="' + profile + '"]');
      return template ? template.innerHTML : '';
    }

    function getResultGroups(rule) {
      var base = rule.recommendation.groups;
      var groups = {
        transmitter: (base.transmitter || []).slice(),
        receivers: (base.receivers || []).slice(),
        accessories: (base.accessories || []).slice()
      };
      var sourceProduct = state.answers.audioSource === 'aux' ? 'oasis_aura' : 'aircast';
      var sourceReason = sourceProduct === 'oasis_aura'
        ? 'Oasis Aura is the standalone transmitter recommended for a computer or another 3.5 mm audio-out device.'
        : 'AirCast is the standalone professional transmitter recommended for a mixer or soundboard.';
      groups.transmitter = [{ productId: sourceProduct, quantity: 1, reason: sourceReason }];
      groups.accessories = [];

      if (state.answers.solutionType === 'audio_distribution') {
        groups.receivers = [{ productId: 'harmony_a0_solo', quantity: 'selectedRange', reason: 'Auracast speaker for synchronized audio across multiple rooms or zones. No personal headphones are included.' }];
      } else if (state.answers.solutionType === 'caption_display') {
        groups.receivers = [{ productId: 'c83', quantity: 'selectedRange', reason: 'Aura C connects each personal phone display to the venue broadcast for the conference caption workflow.' }];
      } else {
        var preferences = getReceiverPreferences().filter(function (value) { return value !== 'not_sure'; });
        var otherPreferences = preferences.filter(function (value) { return value !== 'auraclip'; });
        groups.receivers = [{
          productId: 'auraclip_receiver',
          quantity: otherPreferences.length ? 'receiverMix:auraclip:1' : 'receiverMix:auraclipOnly:1',
          reason: otherPreferences.length
            ? 'AuraClip (VRC-240) provides at least 60% of the receiver plan as the flexible standard option.'
            : 'AuraClip (VRC-240) provides the full receiver range when no additional specialist style is selected.'
        }];
        addPreferredReceiver(groups, otherPreferences, 'auraview', 'auraview_receiver', 'receiverMix:auraview:1', 'AuraView supports clear on-screen selection when several Auracast broadcasts are available at the same time.');
        addPreferredReceiver(groups, otherPreferences, 'wireless_headphones', 'aria_aura', 'receiverMix:wireless_headphones:1', 'Aria Aura provides completely wireless, high-quality listening with an integrated Auracast receiver.');
        addPreferredReceiver(groups, otherPreferences, 'auracoil', 'auracoil_2', 'receiverMix:auracoil:2', 'AuraCoil 2-Pack serves visitors whose hearing aids use T-Coil / telecoil.');
        addPreferredReceiver(groups, otherPreferences, 'auraband', 'auraband_2', 'receiverMix:auraband:2', 'AuraBand 2-Pack is easy for seniors with less arm movement to wear and take off; its slim design fits a church-stool pocket next to a Bible.');
        addPreferredReceiver(groups, otherPreferences, 'aura_c', 'c83', 'receiverMix:aura_c:1', 'Aura C connects personal Bluetooth headphones or older Bluetooth hearing aids through a phone; plan for about 200 ms additional latency.');
      }
      Object.keys(groups).forEach(function (key) {
        groups[key] = groups[key].filter(function (item) { return resolveQuantity(item.quantity) !== '0'; });
      });
      return groups;
    }

    function addPreferredReceiver(groups, preferences, preference, productId, quantity, reason) {
      if (preferences.indexOf(preference) === -1 || hasProduct(groups, productId)) return;
      groups.receivers.push({ productId: productId, quantity: quantity, reason: reason });
    }

    function hasProduct(groups, productId) {
      return groups.transmitter.concat(groups.receivers, groups.accessories).some(function (item) { return item.productId === productId; });
    }

    function renderProductGroup(title, key, items) {
      var body = items.length
        ? items.map(renderProductCard).join('')
        : '<p class="sf-product-group__empty">No additional product was triggered by your answers. Confirm cabling and charging during installation planning.</p>';
      return '<section class="sf-product-group sf-product-group--' + key + '"><div class="sf-product-group__heading"><span aria-hidden="true">' + groupIcon(key) + '</span><div><h3>' + title + '</h3><p>' + getGroupWhy(key) + '</p></div></div><div class="sf-product-list">' + body + '</div></section>';
    }

    function getListeningGroupTitle() {
      if (state.answers.solutionType === 'audio_distribution') return 'Recommended speakers';
      if (state.answers.solutionType === 'caption_display') return 'Recommended caption displays';
      return 'Recommended receivers & listening devices';
    }

    function renderProductCard(item) {
      var product = config.products[item.productId];
      var productUrl = storefrontUrl('products/' + product.handle);
      return '<article class="sf-product-card" data-product-card="' + item.productId + '">' +
        '<a class="sf-product-card__media" href="' + productUrl + '" data-product-link="' + item.productId + '"><img data-product-image hidden alt=""></a>' +
        '<div class="sf-product-card__body">' +
          '<div class="sf-product-card__top"><h4 data-product-title>' + product.fallbackTitle + '</h4><span class="sf-product-card__quantity">Qty: ' + resolveQuantity(item.quantity) + '</span></div>' +
          '<p>' + item.reason + '</p>' +
          '<div class="sf-product-card__footer"><strong data-product-price aria-live="polite"></strong><a href="' + productUrl + '" data-product-link="' + item.productId + '">View product →</a></div>' +
        '</div>' +
      '</article>';
    }

    function renderAdaGuidance() {
      if (state.answers.solutionType !== 'assistive_listening') return '';
      var capacity = state.answers.venueCapacity;
      if (typeof capacity !== 'number') {
        return '<aside class="sf-ada"><div><span>ADA capacity reference</span><h3>Seat count needed</h3></div><div><p>Covered assembly areas use seating capacity to determine the receiver reference. Enter the maximum seat count or confirm the requirement with an expert.</p><a href="https://www.ada.gov/law-and-regs/design-standards/2010-stds/#219-assistive-listening-systems" target="_blank" rel="noopener">Read ADA sections 219 and 706</a></div></aside>';
      }
      var counts = getAdaCounts(capacity);
      var selectedRange = getPlanningRange();
      var selectedTarget = selectedRange ? selectedRange.label : 'not specified';
      var sizingCopy = state.answers.adaCompliance === 'yes'
        ? 'The range containing this capacity reference was pre-selected. Your selected receiver range is ' + selectedTarget + '. ' + (selectedRange && selectedRange.max !== null && selectedRange.max < counts.receivers ? 'This range is below the capacity reference, so confirm it with your accessibility professional.' : 'Confirm the exact quantity within this range during purchasing.')
        : 'The ADA number remains a reference. Your selected planning range is ' + selectedTarget + ' venue-provided receivers.';
      return '<aside class="sf-ada"><div><span>ADA capacity reference</span><h3>' + capacity.toLocaleString() + ' seats → ' + counts.receivers + ' receivers</h3><p class="sf-ada__calculation">' + getAdaCalculation(capacity, counts.receivers) + '</p><p class="sf-ada__compatible">Includes ' + counts.hearingAidCompatible + ' hearing-aid-compatible receivers</p></div>' +
        '<div><p>Table 219.3 provides this minimum when an assistive listening system is required for the assembly area. <strong>' + sizingCopy + '</strong></p><p class="sf-ada__disclaimer">ADA planning is not automatically mandatory for every charitable organization. Coverage depends on the operator and facility. Religious organizations and entities controlled by them are generally exempt from ADA Title III; other nonprofits serving the public may be covered. Verify federal, state and local obligations; this is general planning guidance, not legal advice.</p><a href="https://www.ada.gov/law-and-regs/design-standards/2010-stds/#219-assistive-listening-systems" target="_blank" rel="noopener">Read ADA sections 219 and 706</a></div></aside>';
    }

    function getAdaCounts(capacity) {
      var receivers;
      var compatible;
      if (capacity <= 50) {
        receivers = 2;
        compatible = 2;
      } else if (capacity <= 500) {
        receivers = 2 + Math.ceil((capacity - 50) / 25);
        compatible = capacity <= 200 ? 2 : Math.ceil(receivers / 4);
      } else if (capacity <= 1000) {
        receivers = 20 + Math.ceil((capacity - 500) / 33);
        compatible = Math.ceil(receivers / 4);
      } else if (capacity <= 2000) {
        receivers = 35 + Math.ceil((capacity - 1000) / 50);
        compatible = Math.ceil(receivers / 4);
      } else {
        receivers = 55 + Math.ceil((capacity - 2000) / 100);
        compatible = Math.ceil(receivers / 4);
      }
      return { receivers: receivers, hearingAidCompatible: compatible };
    }

    function getAdaCalculation(capacity, receivers) {
      if (capacity <= 50) return '2 receivers for 50 seats or fewer';
      if (capacity <= 500) return '2 + 1 for every 25 seats over 50 = ' + receivers;
      if (capacity <= 1000) return '20 + 1 for every 33 seats over 500 = ' + receivers;
      if (capacity <= 2000) return '35 + 1 for every 50 seats over 1,000 = ' + receivers;
      return '55 + 1 for every 100 seats over 2,000 = ' + receivers;
    }

    function resolveQuantity(quantity) {
      if (typeof quantity === 'number') return String(quantity);
      if (typeof quantity === 'string' && quantity.indexOf('receiverMix:') === 0) return resolveReceiverPreferenceQuantity(quantity);
      if (quantity === 'selectedRange') return getPlanningRange() ? getPlanningRange().label : 'Confirm range';
      if (quantity === 'sitePlan') return 'Confirm from site plan';
      if (quantity === 'perUser') return '1 per user / display';
      if (quantity === 'adaM3StandardPacks3') return String(getM3AdaPlan().standardPacks);
      if (quantity === 'adaM3TelecoilPacks3') return String(getM3AdaPlan().telecoilPacks);
      if (quantity === 'adaTelecoilKits') {
        var capacity = state.answers.venueCapacity;
        return state.answers.adaCompliance === 'yes' && typeof capacity === 'number' ? String(Math.max(1, Math.ceil(getAdaCounts(capacity).hearingAidCompatible / 3))) : '1 per 3 T-Coil users';
      }
      if (quantity === 'receiverPacks10') {
        var required = getRecommendedReceiverCount();
        return required ? String(Math.ceil(required / 10)) : 'Confirm';
      }
      if (quantity === 'groupPacks10') return resolveGroupPacks(10);
      if (quantity === 'groupPacks6') return resolveGroupPacks(6);
      if (quantity === 'quartetExtras') {
        var listeners = getListenerQuantity();
        return listeners ? String(Math.max(0, listeners - 4)) : 'Confirm';
      }
      if (quantity === 'quartetCharging') return 'Confirm';
      return 'Confirm';
    }

    function resolveGroupPacks(packSize) {
      var listeners = getRecommendedReceiverCount();
      return listeners ? String(Math.ceil(listeners / packSize)) : 'Confirm';
    }

    function resolveReceiverPreferenceQuantity(quantity) {
      var parts = quantity.split(':');
      var preference = parts[1];
      var range = getPlanningRange();
      var rangeLabel = range ? range.label : 'selected range';
      if (preference === 'auraclipOnly') return '100% of ' + rangeLabel;
      if (preference === 'auraclip') return 'At least 60% of ' + rangeLabel;
      return 'Share remaining up to 40%';
    }

    function getRecommendedReceiverCount() {
      var range = getPlanningRange();
      if (!range) return null;
      return range.max === null ? range.min : range.max;
    }

    function getAdaReceiverTarget() {
      return state.answers.adaCompliance === 'yes' && typeof state.answers.venueCapacity === 'number' ? getAdaCounts(state.answers.venueCapacity).receivers : null;
    }

    function getM3AdaPlan() {
      var target = getRecommendedReceiverCount() || 0;
      var compatibleTarget = state.answers.adaCompliance === 'yes' && typeof state.answers.venueCapacity === 'number' ? Math.min(target, getAdaCounts(state.answers.venueCapacity).hearingAidCompatible) : 0;
      var telecoilPacks = compatibleTarget ? Math.max(1, Math.ceil(compatibleTarget / 3)) : 0;
      var receiversAfterCoreAndTelecoil = 3 + (telecoilPacks * 3);
      var standardPacks = target > receiversAfterCoreAndTelecoil ? Math.ceil((target - receiversAfterCoreAndTelecoil) / 3) : 0;
      return { target: target, standardPacks: standardPacks, telecoilPacks: telecoilPacks, provided: receiversAfterCoreAndTelecoil + (standardPacks * 3) };
    }

    function getListenerQuantity() {
      return getRecommendedReceiverCount();
    }

    function buildRequirementsSummary() {
      var solutionType = findLabel(config.solutionTypes, state.answers.solutionType);
      var useCase = findLabel(config.useCases, state.answers.useCase) || 'venue listening';
      var source = findLabel(config.audioSources, state.answers.audioSource);
      var barrier = findLabel(config.barriers, state.answers.barriers);
      var parts = [];
      if (solutionType) parts.push(solutionType);
      parts.push(useCase);
      if (typeof state.answers.venueCapacity === 'number') parts.push(state.answers.venueCapacity.toLocaleString() + '-person maximum capacity');
      if (getPlanningRange()) {
        if (state.answers.solutionType === 'audio_distribution') parts.push(getPlanningRange().label + ' rooms, zones or speakers');
        else if (state.answers.solutionType === 'caption_display') parts.push(getPlanningRange().label + ' personal caption displays');
        else parts.push(getPlanningRange().label + ' planned venue receivers');
      }
      if (source && state.answers.audioSource !== 'not_sure') parts.push(source.toLowerCase());
      if (barrier && state.answers.barriers !== 'not_sure') parts.push(barrier.toLowerCase());
      if (typeof state.answers.rangeFeet === 'number') parts.push(state.answers.rangeFeet + ' ft to the furthest listener');
      var receivers = formatReceiverPreferences();
      if (receivers !== 'Not sure') parts.push(receivers.toLowerCase());
      return parts.join(' · ') + '.';
    }

    function groupIcon(key) {
      if (key === 'transmitter') return '📡';
      if (key === 'receivers' && state.answers.solutionType === 'audio_distribution') return '🔊';
      if (key === 'receivers' && state.answers.solutionType === 'caption_display') return '💬';
      if (key === 'receivers') return '🎧';
      return '🔌';
    }

    function getGroupWhy(key) {
      if (key === 'transmitter') return 'Carries your venue audio into the recommended broadcast system, matched to room size and separation.';
      if (key === 'receivers') {
        if (state.answers.solutionType === 'audio_distribution') return 'Distributes synchronized audio to speakers across the selected number of rooms or zones—without personal headphones.';
        if (state.answers.solutionType === 'caption_display') return 'Connects personal phones to the conference audio so the caption workflow can display live text.';
        return 'Keeps at least 60% of the plan on AuraClip (VRC-240), with the remaining share spread across the selected receiver styles.';
      }
      return 'Adds only the accessories triggered by the selected setup.';
    }

    function findLabel(options, value) {
      var option = options.find(function (item) { return item.value === value; });
      return option ? option.label : '';
    }

    function getRecommendedProductIds(rule) {
      var groups = getResultGroups(rule);
      return groups.transmitter.concat(groups.receivers, groups.accessories).map(function (item) { return item.productId; });
    }

    function fetchRecommendedProducts() {
      var ids = Array.from(new Set(getRecommendedProductIds(state.rule)));
      Promise.all(ids.map(fetchProduct)).then(function () {
        var button = resultHost.querySelector('[data-add-all]');
        var availableCount = ids.filter(function (id) { return loadedProducts[id] && loadedProducts[id].variantId; }).length;
        if (!button) return;
        button.textContent = 'Add All to Cart';
        button.disabled = availableCount === 0;
        if (availableCount < ids.length) {
          var status = resultHost.querySelector('[data-cart-status]');
          if (status) status.textContent = 'Some items need expert confirmation or are not currently available online. Available recommendations can still be added to the cart.';
        }
      });
    }

    function fetchProduct(productId) {
      var product = config.products[productId];
      if (!product) return Promise.resolve(null);
      return fetch(storefrontUrl('products/' + product.handle + '.js'), { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(function (data) {
          var variant = (data.variants || []).find(function (item) { return item.available; }) || (data.variants || [])[0];
          loadedProducts[productId] = { variantId: variant ? variant.id : null, data: data };
          resultHost.querySelectorAll('[data-product-card="' + productId + '"]').forEach(function (card) {
            var title = card.querySelector('[data-product-title]');
            var image = card.querySelector('[data-product-image]');
            var price = card.querySelector('[data-product-price]');
            if (title && data.title) title.textContent = data.title;
            if (image && data.featured_image) {
              image.src = data.featured_image.indexOf('//') === 0 ? 'https:' + data.featured_image : data.featured_image;
              image.alt = data.title || product.fallbackTitle;
              image.hidden = false;
            }
            if (price && typeof data.price === 'number') price.textContent = formatMoney(data.price);
          });
          return data;
        })
        .catch(function () { loadedProducts[productId] = null; return null; });
    }

    function addAllToCart(groups) {
      var button = resultHost.querySelector('[data-add-all]');
      var status = resultHost.querySelector('[data-cart-status]');
      var quantities = {};
      groups.transmitter.concat(groups.receivers, groups.accessories).forEach(function (item) {
        var loaded = loadedProducts[item.productId];
        if (!loaded || !loaded.variantId) return;
        var variantId = String(loaded.variantId);
        quantities[variantId] = (quantities[variantId] || 0) + resolveCartQuantity(item.quantity);
      });
      var items = Object.keys(quantities).map(function (variantId) { return { id: Number(variantId), quantity: quantities[variantId] }; });
      if (!items.length) {
        status.textContent = 'No available products could be added. Please confirm this setup with an expert by email.';
        return;
      }
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch(storefrontUrl('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        track('solution_finder_cta_clicked', { cta_type: 'add_all_to_cart', item_count: items.length, result: state.rule ? state.rule.id : '' });
        window.location.assign(storefrontUrl('cart'));
      }).catch(function () {
        button.disabled = false;
        button.textContent = 'Add All to Cart';
        status.textContent = 'We could not add the setup to the cart. Please review the product links or confirm the setup by email.';
      });
    }

    function resolveCartQuantity(quantity) {
      var resolved = resolveQuantity(quantity);
      return /^\d+$/.test(resolved) ? Math.max(1, Number(resolved)) : 1;
    }

    function formatMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function restart() {
      track('solution_finder_restarted', { previous_result: state.rule ? state.rule.id : '' });
      state.answers = state.presetUseCase ? { solutionType: solutionTypeForUseCase(state.presetUseCase), useCase: state.presetUseCase } : {};
      state.currentIndex = 0;
      state.completed = false;
      state.rule = null;
      state.attemptId = newAttemptId();
      saveSession();
      resultHost.hidden = true;
      questionCard.hidden = false;
      track('solution_finder_started', { start_source: 'restart', entry_page: window.location.pathname + window.location.search, solution_type: state.answers.solutionType || '', use_case: state.answers.useCase || '', category: state.category || '' });
      renderQuestion();
      scrollToTool();
    }

    function setContextBadge() {
      var text = '';
      if (state.presetUseCase) text = 'Context: ' + findLabel(config.useCases, state.presetUseCase);
      else if (state.category) text = 'Entry context: ' + state.category.charAt(0).toUpperCase() + state.category.slice(1);
      contextBadge.textContent = text;
      contextBadge.hidden = !text;
    }

    function advisorUrl() {
      var email = root.getAttribute('data-expert-email') || 'support@venucast.com';
      return 'mailto:' + email + '?subject=' + encodeURIComponent('Please confirm my Venucast setup') + '&body=' + encodeURIComponent(buildSummary());
    }

    function buildSummary() {
      var lines = [
        'Attempt ID: ' + (state.attemptId || 'Not recorded'),
        'System Type: ' + (findLabel(config.solutionTypes, state.answers.solutionType) || 'Not sure'),
        'Scenario: ' + (findLabel(config.useCases, state.answers.useCase) || 'Not sure'),
        'Venue Capacity: ' + (typeof state.answers.venueCapacity === 'number' ? state.answers.venueCapacity : 'Not sure'),
        'ADA Sizing: ' + (state.answers.adaCompliance || 'Not sure'),
        'Planning Quantity Range: ' + (getPlanningRange() ? getPlanningRange().label : 'Not sure'),
        'Preferred Receivers: ' + formatReceiverPreferences(),
        'Audio Source: ' + (findLabel(config.audioSources, state.answers.audioSource) || 'Not sure'),
        'Walls / Separation: ' + (findLabel(config.barriers, state.answers.barriers) || 'Not sure'),
        'Source-to-Last-Row Distance: ' + (typeof state.answers.rangeFeet === 'number' ? state.answers.rangeFeet + ' ft' : 'Not sure')
      ];
      if (state.rule) lines.push('Recommended Setup: ' + state.rule.recommendation.title);
      if (state.answers.notes) lines.push('Notes: ' + state.answers.notes);
      return lines.join('\n');
    }

    function getReceiverPreferences() {
      return Array.isArray(state.answers.receiverPreference) ? state.answers.receiverPreference : [];
    }

    function formatReceiverPreferences() {
      var preferences = getReceiverPreferences();
      if (!preferences.length) return 'Not sure';
      return preferences.map(function (value) { return findLabel(config.receiverPreferences, value); }).filter(Boolean).join(' + ');
    }

    function updateHelpLinks() {
      var summary = encodeURIComponent(buildSummary());
      root.querySelectorAll('[data-finder-help="ask_question"]').forEach(function (link) {
        var base = root.getAttribute('data-question-url') || '/pages/contact-us';
        link.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'source=solution_finder&finder_summary=' + summary;
      });
      root.querySelectorAll('[data-finder-help="book_call"]').forEach(function (link) {
        var base = root.getAttribute('data-book-call-url') || link.href;
        link.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'finder_summary=' + summary;
      });
    }

    function normalizeUseCase(value) {
      if (!value) return '';
      var normalized = value.toLowerCase().trim().replace(/[\s-]+/g, '_');
      var aliases = { assistive: 'assistive_listening', education: 'classroom', auditorium: 'theater', conference: 'meeting', tour: 'guided_tour', venue: 'distributed_audio', fitness: 'gym', outdoor: 'outdoor_party', sports_bar_audio: 'sports_bar' };
      normalized = aliases[normalized] || normalized;
      return config.useCases.some(function (item) { return item.value === normalized; }) ? normalized : '';
    }

    function solutionTypeForUseCase(useCase) {
      var option = config.useCases.find(function (item) { return item.value === useCase; });
      return option ? option.solutionType : '';
    }

    function normalizeTextParam(value) {
      if (!value) return '';
      return value.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40);
    }

    function normalizeEndpoint(value) {
      if (!value || !/^https:\/\//i.test(value)) return '';
      return value;
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character];
      });
    }

    function storefrontUrl(path) {
      return storefrontRoot + String(path || '').replace(/^\/+/, '');
    }

    function newAttemptId() {
      return newUuid();
    }

    function newUuid() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
        var random = Math.floor(Math.random() * 16);
        var value = character === 'x' ? random : (random & 3) | 8;
        return value.toString(16);
      });
    }

    function saveSession() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ answers: state.answers, currentIndex: state.currentIndex, started: state.started, attemptId: state.attemptId }));
      } catch (error) {}
    }

    function restoreSession() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!saved) return;
        state.answers = saved.answers || {};
        state.currentIndex = Number.isInteger(saved.currentIndex) ? saved.currentIndex : 0;
        state.started = Boolean(saved.started);
        state.attemptId = saved.attemptId || '';
      } catch (error) {}
    }

    function track(eventName, properties, useBeacon) {
      var flow = getFlow();
      var payload = Object.assign({
        event_id: newUuid(),
        event: eventName,
        finder_version: config.version,
        attempt_id: state.attemptId || '',
        event_time: new Date().toISOString(),
        page_path: window.location.pathname,
        current_step: state.currentIndex + 1,
        current_question: flow[state.currentIndex] || 'complete'
      }, properties || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        try { window.Shopify.analytics.publish(eventName, payload); } catch (error) {}
      }
      sendToLogEndpoint(payload, Boolean(useBeacon));
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    }

    function sendToLogEndpoint(payload, useBeacon) {
      if (!logEndpoint) return;
      var body = JSON.stringify(payload);
      if (useBeacon && navigator.sendBeacon) {
        navigator.sendBeacon(logEndpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        return;
      }
      fetch(logEndpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
        keepalive: true
      }).catch(function () {});
    }

    function scrollToTool() {
      window.requestAnimationFrame(function () {
        tool.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }
})();
